export const useNoteFeature = (caregiver, errorHandler) => {
    async function retrieveNotes(offset = 0, limit = 10, prioritize_availability_note = 0) {
        return await new Promise((resolve, reject) => {
            axios.get(
                `/api/v1/caregivers/${caregiver.id}/notes`,
                { params: { offset, limit, prioritize_availability_note } }
            ).then(response => {
                caregiver.latest_notes = [...caregiver.latest_notes, ...response.data]
                resolve(response.data)
            }).catch((err) => {
                errorHandler.handleError(err)
                reject({ "error": err })
            })
        });
    }

    async function addNote(noteText) {
        return await new Promise((resolve, reject) => {
            axios.post(
                `/api/v1/caregivers/${caregiver.id}/notes`,
                { notes: noteText }
            ).then(response => {
                let newNote = response.data
                if (newNote) {
                    if (caregiver.latest_notes[0] && !caregiver.latest_notes[0].creator) {
                        caregiver.latest_notes = [
                            caregiver.latest_notes[0],
                            newNote,
                            ...(caregiver.latest_notes.slice(1) || [])
                        ];
                    } else {
                        caregiver.latest_notes = [newNote, ...(caregiver.latest_notes || [])]
                    }
                }
                resolve(response.data)
            }).catch((err) => {
                errorHandler.handleError(err)
                reject({ "error": err })
            })
        });
    }

    return {
        caregiver,
        retrieveNotes, addNote
    }
}
